/** @flow */

import { spawn } from "redux-saga/effects";
import employeeDetailsSaga from "./employee-details";

export default function* employeeSaga(): Generator<*, void, void> {
  yield spawn(employeeDetailsSaga);
}
